/**
 * ストアとして操作中であることを画面の上に出し、「自分に戻る」で切り替え前に戻す（BOARD A-33、2026-10-21）
 * 出すかどうかは、今のトークンが「ストアとして操作中」のもの（operatorActorId 入り）かで決める
 */
import { getStoreActing, stopActingAsStore } from '../utils/storeActing.js';

const ActingAsStoreBanner = () => {
  const acting = getStoreActing();
  if (!acting) return null;

  const handleReturn = () => {
    const returned = stopActingAsStore();
    if (!returned) {
      alert('切り替え前のログイン情報が見つからないため、ログインし直してください');
      window.location.href = '/introduction';
      return;
    }
    window.location.href = '/mystore';
  };

  return (
    <div className="sticky top-0 z-50 bg-amber-600 text-white px-4 py-2 flex items-center justify-between gap-2 text-sm">
      <span>
        🏪 ストア「{acting.storeName}」として操作中です
      </span>
      <button
        onClick={handleReturn}
        className="bg-white text-amber-900 font-semibold px-3 py-1 rounded hover:bg-amber-900 hover:text-white"
      >
        自分に戻る
      </button>
    </div>
  );
};

export default ActingAsStoreBanner;
